
export default function WhyItMatters() {
  const benefits = [
    {
      icon: 'ri-checkbox-circle-line',
      text: 'Your answers reflect reality'
    },
    {
      icon: 'ri-shield-check-line',
      text: 'Controls align with insurer expectations'
    },
    {
      icon: 'ri-hand-heart-line',
      text: 'Coverage remains valid when it matters most'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-[#e10708] via-[#c00607] to-[#a00506]">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-6">
            Why This Matters
          </h2>
          <div className="w-24 h-1 bg-white/50 mx-auto mb-8"></div>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 border border-white/20">
          <p className="text-xl text-white leading-relaxed mb-8 text-center">
            Cyber insurance is no longer just a financial product—it's a <strong>security partnership</strong>. Insurers increasingly expect organizations to demonstrate measurable, enforceable security controls.
          </p>

          <div className="bg-white rounded-xl p-8 mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              Working with an experienced healthcare IT and cybersecurity partner helps ensure:
            </h3>
            
            <div className="grid md:grid-cols-3 gap-6">
              {benefits.map((benefit, index) => (
                <div 
                  key={index}
                  className="flex flex-col items-center text-center"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-[#e10708] to-[#c00607] rounded-full flex items-center justify-center mb-4">
                    <i className={`${benefit.icon} text-3xl text-white`}></i>
                  </div>
                  <p className="text-gray-800 font-semibold leading-relaxed">
                    {benefit.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <a 
              href="/#contact"
              className="inline-flex items-center gap-3 bg-white text-[#e10708] px-8 py-4 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-2xl"></i>
              Schedule Your Cyber Insurance Readiness Review
            </a>
            <p className="text-white/90 mt-4 text-sm">
              Let's ensure your practice is protected and your coverage is valid
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}